export default __webpack_public_path__ + "static/pic5-d37b9378f88a30cb126db2ebc5f9990d.png";